import { getAttributeCreatorFor } from '@leverege/api-attributes'

function jsonToBlueprint( json, blueprints = [] ) {
  if ( !( typeof json.name === 'string' &&
          Array.isArray( json.attributes ) ) ) {
    throw new Error( 'not a blueprint' )
  } 

  const rtn = {
    name : json.name,
    alias : json.alias,
    desc : json.desc || '',
    purpose : json.purpose || 'device',
    tags : [],
    attributes : [],
    errors : [],
    metadata : json.metadata
  }

  if ( Array.isArray( json.tags ) ) {
    json.tags.forEach( ( tag ) => { 
      if ( typeof tag === 'string' ) {
        rtn.tags.push( tag )
      }
    } )
  }

  json.attributes.forEach( ( attr ) => { 
    if ( attr == null || typeof attr !== 'object' || typeof attr.type !== 'string' || typeof attr.path !== 'string' ) {
      rtn.errors.push( attr )
      return
    }
    
    // code to make alias importing work
    if ( attr.type === 'relationship' ) {
      const targetBp = blueprints.find( bp => bp.alias === attr.targetBlueprintId )
      if ( targetBp ) {
        attr.targetBlueprintId = targetBp.id
      }
    }

    const creator = getAttributeCreatorFor( attr.type )
    if ( creator == null ) {
      rtn.errors.push( attr )
      return
    }

    const nAttr = creator.createFrom( attr )
    if ( attr.sim && attr.sim.updater ) {
      nAttr.sim = nAttr.sim || {}
      nAttr.sim.updater = attr.sim.updater
    }
    rtn.attributes.push( nAttr )

  } )
  return rtn
}

const ignore = {
  id : true,
  created : true,
  lastModified : true,
  blueprintId : true,
  projectId : true
}

function replacer( key, value ) {
  if ( ignore[key] ) {
    return undefined
  }
  return value
}

function blueprintToJsonStr( blueprint, blueprints = [] ) {
  const copy = {
    ...blueprint,
    attributes : blueprint.attributes && blueprint.attributes.map( ( attr ) => {
      if ( attr.type === 'relationship' ) {
        const targetBp = blueprints.find( bp => bp.id === attr.targetBlueprintId )
        return {
          ...attr,
          targetBlueprintId : ( targetBp && targetBp.alias ) || attr.targetBlueprintId
        }
      }
      return attr
    } )
  }

  return JSON.stringify( copy, replacer, 2 )
}

export default {
  jsonToBlueprint,
  blueprintToJsonStr
}
